<template>
  <template v-if="donation">
    <section class="mb-8">
      <div class="rounded-lg bg-background p-4">
        <dl class="space-y-1">
          <div>
            <dt
              class="text-xs uppercase leading-loose text-background-fg/70"
            >
              Total
            </dt>
            <dd class="text-3xl font-bold">
              {{
                formatToMerchantCurrencyString(
                  donation.amount
                )
              }}
            </dd>
          </div>
        </dl>
        <div class="my-2 h-px w-full bg-background-fg/8" />
        <dl class="space-y-1">
          <div class="flex items-center justify-between">
            <dt
              v-if="donation.donationNumber !== null"
              class="text-xs uppercase leading-loose text-background-fg/70"
            >
              Donation No.
            </dt>
            <dd class="text-sm font-semibold">
              #{{ donation.donationNumber }}
            </dd>
          </div>
          <div class="flex items-center justify-between">
            <dt
              class="text-xs uppercase leading-loose text-background-fg/70"
            >
              Date
            </dt>
            <dd class="text-sm font-semibold">
              {{ formatToDate(donation.createdAt) }}
            </dd>
          </div>
          <div class="flex items-center justify-between">
            <dt
              class="text-xs uppercase leading-loose text-background-fg/70"
            >
              Time
            </dt>
            <dd class="text-sm font-semibold">
              {{ formatToTime(donation.createdAt) }}
            </dd>
          </div>

          <DonationDetailReceipt
            :donation-id="donationId"
          />
        </dl>
      </div>
    </section>

    <section class="mb-8">
      <h3
        class="mb-3 text-xs uppercase text-background-fg/70"
      >
        Payments
      </h3>
      <div class="rounded-lg bg-background p-4">
        <ol>
          <li>
            <div
              class="flex w-full items-center justify-between space-x-2"
            >
              <div class="flex flex-1 flex-col items-start">
                <div class="mb-1">
                  <PaymentDetailChip
                    :payment="getPaymentMethod(donation)"
                  />
                </div>
                <div class="text-xs text-background-fg/70">
                  {{ formatToDate(donation.createdAt) }}
                </div>
              </div>
              <div class="flex flex-col items-end">
                <p class="font-semibold">
                  {{
                    formatToMerchantCurrencyString(
                      donation.amount
                    )
                  }}
                </p>
              </div>
            </div>
          </li>
        </ol>
      </div>
    </section>
  </template>
</template>

<script setup lang="ts">
import type { Donation } from "@/services/sharedTypes/donation"
import type { PaymentDetailCard } from "@/services/sharedTypes/invoices"

const props = defineProps<{
  donationId: string
}>()

const { data: donation } = useDonation(props.donationId)
const { formatToMerchantCurrencyString } = useCurrency()

const getPaymentMethod = (
  donation_: Donation
): PaymentDetailCard => ({
  transactionMethod: "pos_card",
  cardNumberLast4: donation_.cardNumberLast4 || "",
  cardScheme: donation_.cardScheme || "",
})
</script>
